import type { RectLike } from "../tour-step-card/position-step-card";
import { setTourTestId } from "../tour.utils";

export interface TourSpotlightProps {
  /** Viewport rect of the spotlighted target */
  readonly rect: RectLike;
  /** Extra pixels around the cutout */
  readonly padding?: number;
  /** Let clicks reach the page (the user performs the step's action) */
  readonly interactive?: boolean;
}

/**
 * Dims the whole screen except the target: a transparent box positioned over
 * the target whose oversized box-shadow paints the dark overlay, so no SVG
 * mask is needed. A separate full-screen layer catches clicks while the
 * tour is running, except on interactive steps where the page stays usable.
 */
export function TourSpotlight({ rect, padding = 8, interactive = false }: Readonly<TourSpotlightProps>) {
  return (
    <>
      {!interactive && <div data-testid={setTourTestId("click-catcher")} className="fixed inset-0 z-[60]" aria-hidden="true" />}
      <div
        data-testid={setTourTestId("spotlight")}
        aria-hidden="true"
        className="ring-accent-strong pointer-events-none fixed z-[60] rounded-lg shadow-[0_0_0_100vmax_rgba(0,0,0,0.55)] ring-2 transition-all duration-300"
        style={{
          top: rect.top - padding,
          left: rect.left - padding,
          width: rect.width + padding * 2,
          height: rect.height + padding * 2,
        }}
      />
    </>
  );
}
